/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CheckAppVersionResponseDto } from '../model';
/**
 * AppVersionApi - axios parameter creator
 * @export
 */
export const AppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if mobile app needs update
         * @param {AppVersionControllerCheckVersionPlatformEnum} platform Platform of the mobile app
         * @param {string} currentVersion Current version of the mobile app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerCheckVersion: async (platform: AppVersionControllerCheckVersionPlatformEnum, currentVersion: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('appVersionControllerCheckVersion', 'platform', platform)
            // verify required parameter 'currentVersion' is not null or undefined
            assertParamExists('appVersionControllerCheckVersion', 'currentVersion', currentVersion)
            const localVarPath = `/api/app-version/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (currentVersion !== undefined) {
                localVarQueryParameter['currentVersion'] = currentVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppVersionApi - functional programming interface
 * @export
 */
export const AppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if mobile app needs update
         * @param {AppVersionControllerCheckVersionPlatformEnum} platform Platform of the mobile app
         * @param {string} currentVersion Current version of the mobile app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionControllerCheckVersion(platform: AppVersionControllerCheckVersionPlatformEnum, currentVersion: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAppVersionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionControllerCheckVersion(platform, currentVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppVersionApi.appVersionControllerCheckVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppVersionApi - factory interface
 * @export
 */
export const AppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppVersionApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if mobile app needs update
         * @param {AppVersionControllerCheckVersionPlatformEnum} platform Platform of the mobile app
         * @param {string} currentVersion Current version of the mobile app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerCheckVersion(platform: AppVersionControllerCheckVersionPlatformEnum, currentVersion: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckAppVersionResponseDto> {
            return localVarFp.appVersionControllerCheckVersion(platform, currentVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppVersionApi - object-oriented interface
 * @export
 * @class AppVersionApi
 * @extends {BaseAPI}
 */
export class AppVersionApi extends BaseAPI {
    /**
     * 
     * @summary Check if mobile app needs update
     * @param {AppVersionControllerCheckVersionPlatformEnum} platform Platform of the mobile app
     * @param {string} currentVersion Current version of the mobile app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public appVersionControllerCheckVersion(platform: AppVersionControllerCheckVersionPlatformEnum, currentVersion: string, options?: RawAxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).appVersionControllerCheckVersion(platform, currentVersion, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AppVersionControllerCheckVersionPlatformEnum = {
    Ios: 'ios',
    Android: 'android'
} as const;
export type AppVersionControllerCheckVersionPlatformEnum = typeof AppVersionControllerCheckVersionPlatformEnum[keyof typeof AppVersionControllerCheckVersionPlatformEnum];
